<template>
    <div>
        <clue-data-monitor-reveal></clue-data-monitor-reveal>
        <clue-data-monitor-Business></clue-data-monitor-Business>
        <clue-data-monitor-channel></clue-data-monitor-channel>
    </div>
</template>

<script>
import ClueDataMonitorReveal from './children/clueDataMonitorReveal'
import ClueDataMonitorChannel from './children/clueDataMonitorChannel'
import ClueDataMonitorBusiness from './children/clueDataMonitorBusiness'
import BasicPager from '../../mixins/BasicPager'

export default {
  name: 'clue-data-monitor',
  extends: BasicPager,
  data: function () {
    return {
      datas: []
    }
  },
  components: {
    ClueDataMonitorReveal,
    ClueDataMonitorChannel,
    ClueDataMonitorBusiness
  },
  methods: {}
}
</script>

<style media="screen" scoped>
    #side-menu .router-link-active {
        background: #eee;
    }

    .sidebar {
        width: 200px;
    }

    @media (min-width: 768px) {

        #page-wrapper {
            position: inherit;
            margin: 0 0 0 200px;
            padding: 0 30px;
            border-left: 1px solid #e7e7e7;
        }
    }

</style>
